import React, {useState} from "react"
import {useSelector} from "react-redux"
import InspectionReminder from "./InspectionReminder/InspectionReminder";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid2"
import DoYouWantInspectionReminder from "./InspectionReminder/DoYouWantInspectionReminder";
import {useTranslation} from "react-i18next";
import {ServiceCardType} from "./Types";
import {SelfServiceSettingsType} from '../../interfaces'
import {RootState} from '../../Redux'
import ReturnToStartScreenTimer from "./Common/ReturnToStartScreenTimer";

interface ReservationDoneProps {
    serviceCard: ServiceCardType
}

const ReservationDone = ({serviceCard}: ReservationDoneProps) => {
    const { t } = useTranslation();

    const [inspectionReminder, setInspectionReminder] = useState<boolean>()
    const settings: SelfServiceSettingsType = useSelector((state: RootState) => state.ui.settings?.selfService ?? {});

    const onReminderBack = () => {
        setInspectionReminder(undefined)
    }

    if (inspectionReminder !== undefined) {
        return (
            <InspectionReminder
                orderReminder={inspectionReminder}
                serviceCard={serviceCard}
                onBack={onReminderBack}
            />
        )
    }

    return (<>
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid>
            </Grid>
            <Typography variant="h4" gutterBottom>{t('selfService.reservationSucceeded')}</Typography>
            <ReturnToStartScreenTimer time={60}/>
            {settings.inspectionReminderAvailable ? <DoYouWantInspectionReminder onSelect={setInspectionReminder}/> : null}
            <Grid>
            </Grid>
        </Grid>
    </>)
}

export default ReservationDone
